const CHATBOT_AI_TEMPLATES = [
    {
        slug: "tourism-sector",
        visible: true,
        enabled: true,
        name: {
            en: "Tourism Sector",
            tr: "Turizm Sektörü",
        },
        shortDescription: {
            en: "Tourism Sector",
            tr: "Turizm Sektörü",
        },
        description: {
            en: "An example chatbot prepared for the tourism sector.",
            tr: "Turizm sektörü için hazırlanmış bir chatbot örneği.",
        },
        imageUrl: "/static/img/chatbot/travel-holiday-vacation-14-svgrepo-com.svg",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: {
            en: ["advanced", "artificial-intelligent", "automation"],
            tr: ["ileri-seviye", "yapay-zeka", "otomasyon"],
        },
        updatedAt: "2024-04-07T00:00:00.000Z",
    },
    {
        slug: "e-commerce-one",
        visible: true,
        enabled: true,
        name: {
            en: "E-Commerce (1)",
            tr: "E-Ticaret (1)",
        },
        shortDescription: {
            en: "E-Commerce (1)",
            tr: "E-Ticaret (1)",
        },
        description: {
            en: "An example chatbot prepared for the e-commerce sector.",
            tr: "E-ticaret sektörü için hazırlanmış bir chatbot örneği.",
        },
        imageUrl: "/static/img/chatbot/export-shipment-trade-svgrepo-com.svg",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: {
            en: ["advanced", "artificial-intelligent", "automation"],
            tr: ["ileri-seviye", "yapay-zeka", "otomasyon"],
        },
        updatedAt: "2024-04-07T00:00:00.000Z",
    },
    {
        slug: "e-commerce-two",
        visible: true,
        enabled: true,
        name: {
            en: "E-Commerce (2)",
            tr: "E-Ticaret (2)",
        },
        shortDescription: {
            en: "E-Commerce (2)",
            tr: "E-Ticaret (2)",
        },
        description: {
            en: "An example chatbot prepared for the e-commerce sector.",
            tr: "E-ticaret sektörü için hazırlanmış bir chatbot örneği.",
        },
        imageUrl: "/static/img/chatbot/export-shipment-trade-svgrepo-com.svg",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: {
            en: ["advanced", "artificial-intelligent", "automation"],
            tr: ["ileri-seviye", "yapay-zeka", "otomasyon"],
        },
        updatedAt: "2024-04-07T00:00:00.000Z",
    },
    {
        slug: "e-commerce-three",
        visible: true,
        enabled: true,
        name: {
            en: "E-Commerce (3)",
            tr: "E-Ticaret (3)",
        },
        shortDescription: {
            en: "E-Commerce (3)",
            tr: "E-Ticaret (3)",
        },
        description: {
            en: "An example chatbot prepared for the e-commerce sector.",
            tr: "E-ticaret sektörü için hazırlanmış bir chatbot örneği.",
        },
        imageUrl: "/static/img/chatbot/export-shipment-trade-svgrepo-com.svg",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: {
            en: ["advanced", "artificial-intelligent", "automation"],
            tr: ["ileri-seviye", "yapay-zeka", "otomasyon"],
        },
        updatedAt: "2024-04-07T00:00:00.000Z",
    },
    {
        slug: "health-tourism",
        visible: true,
        enabled: true,
        name: {
            en: "Health Tourism",
            tr: "Sağlık Turizmi",
        },
        shortDescription: {
            en: "Health Tourism",
            tr: "Sağlık Turizmi",
        },
        description: {
            en: "An example chatbot prepared for the health tourism sector.",
            tr: "Sağlık turizmi sektörü için hazırlanmış bir chatbot örneği.",
        },
        imageUrl: "/static/img/chatbot/hospital-svgrepo-com.svg",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: {
            en: ["advanced", "artificial-intelligent", "automation"],
            tr: ["ileri-seviye", "yapay-zeka", "otomasyon"],
        },
        updatedAt: "2024-04-07T00:00:00.000Z",
    },
    {
        slug: "university-sector",
        visible: true,
        enabled: true,
        name: {
            en: "University Sector",
            tr: "Üniversite Sektörü",
        },
        shortDescription: {
            en: "University Sector",
            tr: "Üniversite Sektörü",
        },
        description: {
            en: "An example chatbot prepared for the university sector.",
            tr: "Üniversite sektörü için hazırlanmış bir chatbot örneği.",
        },
        imageUrl: "/static/img/chatbot/school-svgrepo-com.svg",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: {
            en: ["advanced", "artificial-intelligent", "automation"],
            tr: ["ileri-seviye", "yapay-zeka", "otomasyon"],
        },
        updatedAt: "2024-04-07T00:00:00.000Z",
    },
    {
        slug: "questionnaire-bot",
        visible: true,
        enabled: true,
        name: {
            en: "Questionnaire Bot",
            tr: "Anket Botu",
        },
        shortDescription: {
            en: "Questionnaire Bot",
            tr: "Anket Botu",
        },
        description: {
            en: "An example chatbot prepared for the questionnaire sector.",
            tr: "Anket sektörü için hazırlanmış bir chatbot örneği.",
        },
        imageUrl: "/static/img/chatbot/career-job-management-svgrepo-com.svg",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: {
            en: ["advanced", "artificial-intelligent", "automation"],
            tr: ["ileri-seviye", "yapay-zeka", "otomasyon"],
        },
        updatedAt: "2024-04-07T00:00:00.000Z",
    },
    {
        slug: "language-school",
        visible: true,
        enabled: true,
        name: {
            en: "Language School",
            tr: "Dil Okulu",
        },
        shortDescription: {
            en: "Language School",
            tr: "Dil Okulu",
        },
        description: {
            en: "An example chatbot prepared for the language school sector.",
            tr: "Dil okulu sektörü için hazırlanmış bir chatbot örneği.",
        },
        imageUrl: "/static/img/chatbot/english-translator.svg",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: {
            en: ["advanced", "artificial-intelligent", "automation"],
            tr: ["ileri-seviye", "yapay-zeka", "otomasyon"],
        },
        updatedAt: "2024-04-07T00:00:00.000Z",
    },
    {
        slug: "restaurant-industry",
        visible: true,
        enabled: true,
        name: {
            en: "Restaurant Industry",
            tr: "Restoran Sektörü",
        },
        shortDescription: {
            en: "Restaurant Industry",
            tr: "Restoran Sektörü",
        },
        description: {
            en: "An example chatbot prepared for the restaurant industry sector.",
            tr: "Restoran sektörü için hazırlanmış bir chatbot örneği.",
        },
        imageUrl: "/static/img/chatbot/restaurant-coffee-shop-svgrepo-com.svg",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: {
            en: ["advanced", "artificial-intelligent", "automation"],
            tr: ["ileri-seviye", "yapay-zeka", "otomasyon"],
        },
        updatedAt: "2024-04-07T00:00:00.000Z",
    },
    {
        slug: "sports-school-tennis-club",
        visible: true,
        enabled: true,
        name: {
            en: "Sports School Tennis Club",
            tr: "Spor Okulu Tenis Kulübü",
        },
        shortDescription: {
            en: "Sports School Tennis Club",
            tr: "Spor Okulu Tenis Kulübü",
        },
        description: {
            en: "An example chatbot prepared for the sports school tennis club sector.",
            tr: "Spor okulu tenis kulübü sektörü için hazırlanmış bir chatbot örneği.",
        },
        imageUrl: "/static/img/chatbot/football-field-svgrepo-com.svg",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: {
            en: ["advanced", "artificial-intelligent", "automation"],
            tr: ["ileri-seviye", "yapay-zeka", "otomasyon"],
        },
        updatedAt: "2024-04-07T00:00:00.000Z",
    },
    {
        slug: "ideasoft-bot",
        visible: true,
        enabled: true,
        name: {
            en: "Ideasoft Bot",
            tr: "Ideasoft Bot",
        },
        shortDescription: {
            en: "Ideasoft Bot",
            tr: "Ideasoft Bot",
        },
        description: {
            en: "An example chatbot prepared for the Ideasoft sector.",
            tr: "Ideasoft sektörü için hazırlanmış bir chatbot örneği.",
        },
        imageUrl: "/static/img/chatbot/reception-person-people-demo-svgrepo-com.svg",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: {
            en: ["advanced", "artificial-intelligent", "automation"],
            tr: ["ileri-seviye", "yapay-zeka", "otomasyon"],
        },
        updatedAt: "2024-04-07T00:00:00.000Z",
    },
    {
        slug: "e-commerce-textile",
        visible: true,
        enabled: true,
        name: {
            en: "E-Commerce Textile",
            tr: "E-Ticaret Tekstil",
        },
        shortDescription: {
            en: "E-Commerce Textile",
            tr: "E-Ticaret Tekstil",
        },
        description: {
            en: "An example chatbot prepared for the e-commerce textile sector.",
            tr: "E-ticaret tekstil sektörü için hazırlanmış bir chatbot örneği.",
        },
        imageUrl: "/static/img/chatbot/export-shipment-trade-svgrepo-com.svg",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: {
            en: ["advanced", "artificial-intelligent", "automation"],
            tr: ["ileri-seviye", "yapay-zeka", "otomasyon"],
        },
        updatedAt: "2024-04-07T00:00:00.000Z",
    },
    {
        slug: "automotive-industry",
        visible: true,
        enabled: true,
        name: {
            en: "Automotive Industry",
            tr: "Otomotiv Sektörü",
        },
        shortDescription: {
            en: "Automotive Industry",
            tr: "Otomotiv Sektörü",
        },
        description: {
            en: "An example chatbot prepared for the automotive industry sector.",
            tr: "Otomotiv sektörü için hazırlanmış bir chatbot örneği.",
        },
        imageUrl: "/static/img/chatbot/car-svgrepo-com.svg",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: {
            en: ["advanced", "artificial-intelligent", "automation"],
            tr: ["ileri-seviye", "yapay-zeka", "otomasyon"],
        },
        updatedAt: "2024-04-07T00:00:00.000Z",
    },
    {
        slug: "department-bot",
        visible: true,
        enabled: true,
        name: {
            en: "Department Bot",
            tr: "Departman Botu",
        },
        shortDescription: {
            en: "Department Bot",
            tr: "Departman Botu",
        },
        description: {
            en: "An example chatbot prepared for the department sector.",
            tr: "Departman sektörü için hazırlanmış bir chatbot örneği.",
        },
        imageUrl: "/static/img/chatbot/reception-person-people-demo-svgrepo-com.svg",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: {
            en: ["advanced", "artificial-intelligent", "automation"],
            tr: ["ileri-seviye", "yapay-zeka", "otomasyon"],
        },
        updatedAt: "2024-04-07T00:00:00.000Z",
    },
    {
        slug: "fair-course-chatbot",
        visible: true,
        enabled: true,
        name: {
            en: "Fair Course Chatbot",
            tr: "Fuar Kurs Chatbotu",
        },
        shortDescription: {
            en: "Fair Course Chatbot",
            tr: "Fuar Kurs Chatbotu",
        },
        description: {
            en: "An example chatbot prepared for the fair course sector.",
            tr: "Fuar kursu sektörü için hazırlanmış bir chatbot örneği.",
        },
        imageUrl: "/static/img/chatbot/exhibition-museum-svgrepo-com.svg",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: {
            en: ["advanced", "artificial-intelligent", "automation"],
            tr: ["ileri-seviye", "yapay-zeka", "otomasyon"],
        },
        updatedAt: "2024-04-07T00:00:00.000Z",
    },
    {
        slug: "insurance-industry",
        visible: true,
        enabled: true,
        name: {
            en: "Insurance Industry",
            tr: "Sigorta Sektörü",
        },
        shortDescription: {
            en: "Insurance Industry",
            tr: "Sigorta Sektörü",
        },
        description: {
            en: "Insurance Industry Chatbot Example",
            tr: "Sigorta Sektörü Chatbot Örneği",
        },
        imageUrl: "/static/img/chatbot/browser-svgrepo-com.svg",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: {
            en: ["advanced", "artificial-intelligent", "automation"],
            tr: ["ileri-seviye", "yapay-zeka", "otomasyon"],
        },
        updatedAt: "2024-04-07T00:00:00.000Z",
    },
];

export default CHATBOT_AI_TEMPLATES;
